<template>
  <div class="details-reader">
    <template v-for="(value, key) in details">
      <div
        :key="`${_uid}-${key}`"
        class="app-key-value__list">
        <template v-if="typeValue(value) === TYPE_VALUE.array">
          <div class="details-reader__wrp-array">
            <details-reader-array
              :details-key="key"
              :details-value="value"
              :with-accordion="withAccordion"
              :copyable="copyable"
              :formatters="formatters"
              :shortable="shortable"
            />
          </div>
        </template>

        <template
          v-if="
            typeValue(value) === TYPE_VALUE.object && isNotEmptyObject(value)"
        >
          <div class="details-reader__wrp-object">
            <details-reader-object
              :details-key="key"
              :details-value="value"
              :with-accordion="withAccordion"
              :shortable="shortable"
              :formatters="formatters"
              :copyable="copyable"
            />
          </div>
        </template>

        <template v-if="typeValue(value) === TYPE_VALUE.primitive">
          <div class="details-reader__wrp-primitive">
            <details-reader-primitive
              :details-key="key"
              :details-value="value"
              :copyable="copyable"
              :shortable="shortable"
              :formatters="formatters"
            />
          </div>
        </template>
      </div>
    </template>
  </div>
</template>

<script>
import DetailsReaderArray from '@/vue/common/DetailsReader/DetailsReaderArray'
import DetailsReaderObject from '@/vue/common/DetailsReader/DetailsReaderObject'
import DetailsReaderPrimitive from '@/vue/common/DetailsReader/DetailsReaderPrimitive'
import _isEmpty from 'lodash/isEmpty'

const TYPE_VALUE = {
  array: 'array',
  object: 'object',
  primitive: 'primitive',
}

export default {
  name: 'details-reader',

  components: {
    DetailsReaderArray,
    DetailsReaderObject,
    DetailsReaderPrimitive,
  },

  props: {
    details: {
      type: [Object, Array],
      required: true,
    },
    withAccordion: {
      type: Boolean,
      default: false,
    },
    copyable: {
      type: Boolean,
      default: false,
    },
    shortable: {
      type: Boolean,
      default: false,
    },
    formatters: {
      /* example
      *
      * [
        {
          key: 'birthDate',
          formatter: (value) => {
            const date = formatDate(value)
            return date
          }
        }
      ]
      * */
      type: [Array],
      default: () => [],
    },
  },

  data () {
    return {
      TYPE_VALUE,
      isNotEmptyObject: (obj) => { return !_isEmpty(obj) },
    }
  },
  methods: {
    isArray (value) {
      const result = Array.isArray(value)
      return result
    },

    isObject (value) {
      return value && typeof value === 'object'
    },

    typeValue (value) {
      if (this.isArray(value)) {
        return TYPE_VALUE.array
      } else if (this.isObject(value)) {
        return TYPE_VALUE.object
      } else {
        return TYPE_VALUE.primitive
      }
    },
  },
}
</script>

<style lang="scss">
@import './details-reader';
</style>
